import { Modal } from "@/components/ui";
import { HOME_BLOCK_TYPE_LABELS, type HomeBlock } from "@/lib/api";
import { formatDateTime } from "@/lib/utils/format";

export function HomeBlockPreviewModal({ block, onClose }: { block: HomeBlock | null; onClose: () => void }) {
  return (
    <Modal open={block !== null} onClose={onClose} title="Vista previa del bloque" size="sm">
      {block && (
        <div className="space-y-4">
          <p className="text-xs font-medium uppercase tracking-wide text-ink-faint">
            {HOME_BLOCK_TYPE_LABELS[block.type]} - asi se veria en Inicio
          </p>

          <div className="overflow-hidden rounded-xl border border-ink/10 shadow-card">
            {block.imageUrl && (
              // eslint-disable-next-line jsx-a11y/alt-text
              <img src={block.imageUrl} alt="" className="h-32 w-full object-cover" />
            )}
            <div className="space-y-1.5 bg-white p-4">
              {block.subtitle && (
                <p className="text-xs font-medium uppercase tracking-wide text-brand-700">{block.subtitle}</p>
              )}
              {block.title && <p className="text-base font-semibold text-ink">{block.title}</p>}
              {block.body && <p className="text-sm text-ink-muted">{block.body}</p>}
              {block.actionLabel && (
                <span className="mt-2 inline-block text-sm font-medium text-brand-700">
                  {block.actionLabel} &rarr;
                </span>
              )}
            </div>
          </div>

          <dl className="grid grid-cols-2 gap-3 text-sm">
            <div>
              <dt className="text-xs text-ink-faint">Visible desde</dt>
              <dd className="text-ink">{formatDateTime(block.startsAt)}</dd>
            </div>
            <div>
              <dt className="text-xs text-ink-faint">Visible hasta</dt>
              <dd className="text-ink">{formatDateTime(block.endsAt)}</dd>
            </div>
          </dl>
        </div>
      )}
    </Modal>
  );
}
